import React, {useEffect, useState} from 'react';
import "./index.css";


function NotFound(){

	let [count, setCount] = useState(15)

	useEffect(()=>{
		let redirection = () => {
			window.location.href = "/"			
		}

		count > 0 ? setTimeout(()=>setCount(count - 1), 1000) : redirection()
	}, [count])

	return(
		<section id="notfound">

			<div>
				PAGE UNKNOWN!
			</div>

			<article>
				<p>Seems like you just <span className="arts">discovered</span> a new internet page. In
				<br />  <span className='enlarge'> {count} </span> <br /> seconds,
				Let's direct you to <a href="/" > a pro who can build something on the internet for you! </a> </p>				
			</article>

		</section>


		)
};

export default NotFound;